import { z } from 'zod';

import { PaginationResponseSchema } from '@/shared/global.schema';

export const SingleSupplierSchema = z.object({
    id: z.string(),
    created_at: z.string(),
    created_by: z.string().optional().nullable(),
    name: z.string(),
    address: z.string().nullable().optional(),
    phone_number: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    brand_id: z.string().nullable().optional(),
    total_purchases: z.number().optional(),
    average_purchase_value: z.number().optional(),
    last_purchase_date: z.string().nullable().optional(),
    total_paid: z.number().optional(),
    total_price: z.number().optional(),
    total_due: z.number().optional(),
});
export type TSupplierDetails = z.infer<typeof SingleSupplierSchema>;

export const SupplierListItemSchema = SingleSupplierSchema;

export type TSupplierListItem = z.infer<typeof SupplierListItemSchema>;

export const SupplierResponseSchema = z.object({
    data: z.array(SupplierListItemSchema),
    pagination: PaginationResponseSchema,
});

export const SupplierListResponseSchema = SupplierResponseSchema;
export type TSupplierListResponse = z.infer<typeof SupplierListResponseSchema>;

export const SingleSupplierResponseSchema = z.object({
    data: SingleSupplierSchema,
    message: z.string().optional(),
});
export type TSupplierDetailsResponse = z.infer<
    typeof SingleSupplierResponseSchema
>;

export type SupplierType = z.infer<typeof SingleSupplierSchema>;

export type SingleSupplierResponseType = z.infer<
    typeof SingleSupplierResponseSchema
>;

export type SupplierResponseType = z.infer<typeof SupplierResponseSchema>;
